import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Navigate to the previous history entry when possible.
 * Falls back to a route when there's no usable browser history.
 */
export function useBackNavigation(fallbackPath = '/') {
  const navigate = useNavigate();

  return useCallback(() => {
    if (typeof window === 'undefined') {
      navigate(fallbackPath, { replace: true });
      return;
    }

    // React Router stores an in-app history index in history.state.idx.
    // Prefer this over history.length to avoid navigating to browser blank/new-tab entries.
    const historyState = window.history.state as { idx?: number } | null;
    const canGoBackInApp = typeof historyState?.idx === 'number'
      ? historyState.idx > 0
      : window.history.length > 1;

    if (canGoBackInApp) {
      navigate(-1);
      return;
    }

    navigate(fallbackPath, { replace: true });
  }, [fallbackPath, navigate]);
}
